import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { TrxServicesMethodPage } from './trxservices-method.page';

const routes: Routes = [
  {
    path: '',
    component: TrxServicesMethodPage,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes), TranslateModule],
  exports: [RouterModule],
})
export class TrxServicesMethodPageRoutingModule {}
